module.exports = __webpack_public_path__ + "static/media/versus-dragos.58c35382.jpg";